import { callApi } from "./ApiClient";

const getUserMails = (dispatch) => {
  return callApi("GET", "/user_mails", null, dispatch);
};

const postUserMails = (data, dispatch) => {
  return callApi("POST", "/user_mails", data, dispatch);
};

const deleteUserMailsById = (id, dispatch) => {
  return callApi("DELETE", `/user_mails/${id}`, null, dispatch);
};

const putUserMails = (id, data, dispatch) => {
  return callApi("PUT", `/user_mails/${id}`, data, dispatch);
};

export const UserMailsApi = {
  getUserMails,
  postUserMails,
  deleteUserMailsById,
  putUserMails,
};



// WEBPACK FOOTER //
// ./src/redux/api/UserMailsApi.js